<section id="about">
    <div class="grid-container">
        <div>
            <h3 class="title">درباره ما</h3>

            <p class="text-justify" style="line-height: 30px;text-align: justify;">
                سامانه <strong>TankerGPS</strong> با مدیریت و به درخواست شرکت آب و فاضلاب استان اصفهان و با همکاری شرکت
                <strong>دانش‌بنیان رایان
                    اندیشه نصر</strong> ایجاد شده است تا بستری هوشمند، شفاف و قابل اعتماد برای پایش، مدیریت و سامان‌دهی
                ناوگان
                تانکرهای آبرسان فراهم کند. این سامانه با هدف نظارت لحظه‌ای بر عملیات آبگیری و توزیع آب، مدیریت بهینه
                ناوگان آبرسان، افزایش شفافیت در فرآیند تأمین و تحویل آب، جلوگیری از تخلفات، بهبود پاسخگویی به مشترکین
                به‌ویژه در مناطق روستایی و کم‌برخوردار و همچنین افزایش آمادگی در شرایط بحرانی و اضطراری طراحی و
                پیاده‌سازی شده است. TankerGPS با بهره‌گیری از فناوری‌های نوین مکان‌یابی، پایش هوشمند و گزارش‌گیری دقیق،
                تلاش می‌کند کارایی، عدالت در توزیع آب، نظارت مؤثر و اعتماد عمومی را افزایش داده و گامی مؤثر در راستای
                مدیریت هوشمند منابع آب، ارتقای کیفیت خدمات‌رسانی و پایداری شبکه آبرسانی سیار بردارد.
            </p>

        </div>
        <div>
            <h3 class="title">راه های ارتباطی</h3>

            <div class="">

                <ul style="line-height: 33px;">

                    <ng-container *ngFor="let item of lst_Contact">

                        <li><strong>{{item.title}}: </strong> {{ item.description | faNum}} </li>

                    </ng-container>

                </ul>

            </div>

        </div>

    </div>

</section>

<footer id="site-footer">
    <div class="inner-content">
        <div class="flex-container">
            <a href="https://rayanandisheh.com" class="copyright" target="_blank">طراحی و توسعه شرکت دانش بنیان رایان
                اندیشه نصر</a>
        </div>
    </div>
</footer>